import { GatePass } from './_models/gate_pass';
import { AuthService } from 'src/app/_services/auth.service';
import { SearchEngineDataService } from './_services/search-engine-data.service';
import { HostBinding,  Optional } from '@angular/core';
import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  name = 'NavigationBarProject';


  @HostBinding("class.drawer-open")
  isDrawerOpen: boolean = false;

  constructor(@Optional() private metaDataService: SearchEngineDataService,private authService:AuthService) {

   }

  ngOnInit(): void {

    this.initMetaData()


   }

  toggleDrawer(isDrawerOpen: boolean) {
    this.isDrawerOpen = isDrawerOpen;
  }
  initMetaData(): void {
    if (this.metaDataService) {
      this.metaDataService.updateMetadata({
        title: 'Boldungu for Smart math practice for primary school children',
        description: 'Practice and pass mathematics with fun. Aligned with national curriculum',
        author:"Boldungu Team"
      });
    }
  }





}
